import react from "react";
import { Typography, Container, Box } from "@mui/material";

// Components
import Layout from "../components/layout";

// import { styled } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { NotPageTheme, NotPageThemeText } from "@/styles/mui/tableListTheme";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
const DenyPage = (props) => {
  const { open, setOpen } = props;
  const navigate = useNavigate();

  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={25}
      open={open}
      setOpen={setOpen}
    >
      <ThemeProvider theme={NotPageTheme}>
        <Container maxWidth={"100%"}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 5,
            }}
          >
            <ThemeProvider theme={NotPageThemeText}>
              <Typography variant="h1" component="h1">
                403
              </Typography>
            </ThemeProvider>
            <Typography variant="h2" color={"black"}>
              Permission Deny
            </Typography>
            <Button onClick={() => navigate(-1)}>返回上一頁</Button>
          </Box>
        </Container>
      </ThemeProvider>
    </Layout>
  );
};

export default DenyPage;
